import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormCheckbox from "../../components/formFields/FormCheckbox";
import {
  getOrganizationByID,
  updateSoftwareSetting,
} from "./services/organizationRegister.services";
import { closeDialog } from "../../components/dialog/dialogSlice";
import AppDialog from "../../components/dialog/Dialog";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { clearSoftwareSettingDetail } from "./organizationRegisterSlice";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useEffect, useState } from "react";

const gridItemStyle = {
  border: "1px solid whitesmoke",
  padding: 10,
  borderRadius: 10,
};

const SoftwareSettingDialog = () => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const SoftwareSettingDetail = useAppSelector(
    (state) => state.organizationRegister.SoftwareSettingDetail,
  );
  const settingLoading = useAppSelector(
    (state) => state.organizationRegister.settingLoading,
  );
  const [formKey, setFormKey] = useState(0);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [SoftwareSettingDetail]);

  const handleSubmit = async (values: any) => {
    if (SoftwareSettingDetail?.ID) {
      const payload = {
        ID: SoftwareSettingDetail?.ID,
        Crm: values?.Crm || false,
        Hotel: values?.Hotel || false,
        Flight: values?.Flight || false,
        Visa: values?.Visa || false,
        IsWebsite: values?.IsWebsite || false,
      };
      const response = await dispatch(updateSoftwareSetting(payload));
      if (response.meta.requestStatus === "fulfilled") {
        setFormKey(formKey + 1);
        dispatch(getOrganizationByID(SoftwareSettingDetail?.ID));
        dispatch(closeDialog());
        dispatch(clearSoftwareSettingDetail());
      }
      // else {
      //   dispatch(getOrganizationByID(SoftwareSettingDetail?.ID));
      //   dispatch(closeDialog());
      //   dispatch(clearSoftwareSettingDetail());
      // }
    }
  };

  return (
    <>
      {dialogName === "softwareSettingDialog" && (
        <AppDialog>
          <Form
            key={formKey}
            onSubmit={handleSubmit}
            initialValues={SoftwareSettingDetail}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ minWidth: 400 }}>
                <GridLayout
                  style={{ marginRight: 10 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "50%" }, { width: "50%" }]}
                >
                  <GridLayoutItem colSpan={2}>
                    <Typography.h4>Software Settings</Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem style={gridItemStyle}>
                    <Field
                      wrapperClassName="m-0"
                      key={"Crm"}
                      name={"Crm"}
                      label={"CRM Module"}
                      component={FormCheckbox}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem style={gridItemStyle}>
                    <Field
                      wrapperClassName="m-0"
                      key={"Hotel"}
                      name={"Hotel"}
                      label={"Hotel Module"}
                      component={FormCheckbox}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem style={gridItemStyle}>
                    <Field
                      wrapperClassName="m-0"
                      key={"Flight"}
                      name={"Flight"}
                      label={"Flight Module"}
                      component={FormCheckbox}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem style={gridItemStyle}>
                    <Field
                      wrapperClassName="m-0"
                      key={"Visa"}
                      name={"Visa"}
                      label={"Visa Module"}
                      component={FormCheckbox}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem style={gridItemStyle}>
                    <Field
                      wrapperClassName="m-0"
                      key={"IsWebsite"}
                      name={"IsWebsite"}
                      label={"Website Module"}
                      component={FormCheckbox}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem
                    colSpan={2}
                    className="d-flex justify-content-end align-items-center gap-2 mt-4"
                  >
                    <ButtonWithLoading
                      label={"Save"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || settingLoading}
                      loading={settingLoading}
                    />
                    <Button
                      type="button"
                      fillMode={"outline"}
                      themeColor={"primary"}
                      onClick={() => {
                        dispatch(closeDialog());
                        dispatch(clearSoftwareSettingDetail());
                        setFormKey(formKey + 1);
                      }}
                    >
                      Cancel
                    </Button>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            )}
          />
        </AppDialog>
      )}
    </>
  );
};

export default SoftwareSettingDialog;
